var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10197",
    "data-name": "Group 10197",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13.974,
    height: 12,
    viewBox: "0 0 13.974 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_479",
    "data-name": "Rectangle 479",
    width: 13.974,
    height: 12,
    fill: "#152c40"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2822",
    "data-name": "Group 2822",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10616",
    "data-name": "Path 10616",
    d: "M.737,6.288a6.272,6.272,0,0,1,1.73-3.676L3.535,3.681l.495-.495L2.982,2.138A6.262,6.262,0,0,1,6.638.708V2.445h.7V.708a6.262,6.262,0,0,1,3.656,1.43L9.986,3.144l.495.495,1.026-1.026a6.272,6.272,0,0,1,1.73,3.676h-1.47v.7h1.508a6.255,6.255,0,0,1-1.434,3.992l-1.2-1.2-.495.495,1.215,1.214,0,.006.486.5a6.988,6.988,0,1,0-9.826-.1l.495-.493L2.513,11.4l1.049-1.05-.495-.5L2.049,10.874A6.249,6.249,0,0,1,.7,6.987H2.114v-.7Z",
    transform: "translate(0 0)",
    fill: "#152c40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10617",
    "data-name": "Path 10617",
    d: "M16.94,16.946l-4.876.451a.56.56,0,0,0-.341.207l-.573.85a.843.843,0,0,0,.233.866l.92.449a.575.575,0,0,0,.4.011l4.441-2.052c.661-.23.484-.913-.2-.783M12.517,19.1l2.813-1.3-3.084.284-.42.622c0,.029,0,.046,0,.054Zm-.7-.347,0,0s0,0,0,0",
    transform: "translate(-5.943 -9.044)",
    fill: "#152c40",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon5);
export default __webpack_public_path__ + "static/media/social-icon5.cb423d95481d7aaa52c2b8c92063cb31.svg";
export { ForwardRef as ReactComponent };